import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import TopicWall from "./components/TopicWall";
import EvidenceList from "./components/EvidenceList";
import TimelineSpotlight from "./components/TimelineSpotlight";
import HotRank from "./components/HotRank";
import ContrastSection from "./components/ContrastSection";
import ArchiveGrid from "./components/ArchiveGrid";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopNav />
      <main>
        <Hero />
        <TopicWall />
        <EvidenceList />
        <TimelineSpotlight />
        <HotRank />
        <ContrastSection />
        <ArchiveGrid />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}